import { Role } from "../../types/role";

const DFLve: Role = {
  primary: [
    "Technik",
    "Antizipation",
    "Einsatzfreude",
    "OhneBall",
    "Stellungsspiel",
    "Teamwork",
    "Ausdauer",
  ],
  secondary: [
    "Ballannahme",
    "Deckung",
    "Dribbling",
    "Flanken",
    "Tackling",
    "Aggressivitaet",
    "Entscheidungen",
    "Konzentration",
    "Antritt",
  ],
  physis: "mittelfeld",
};
const DFLun: Role = {
  primary: [
    "Flanken",
    "Technik",
    "Einsatzfreude",
    "OhneBall",
    "Teamwork",
    "Ausdauer",
  ],
  secondary: [
    "Ballannahme",
    "Deckung",
    "Dribbling",
    "Passen",
    "Tackling",
    "Aggressivitaet",
    "Antizipation",
    "Entscheidungen",
    "Konzentration",
    "Nervenstaerke",
    "Stellungsspiel",
    "Antritt",
  ],
  physis: "mittelfeld",
};

export const DFL = {
  DFLve,
  DFLun,
};
